import { localAPI } from "../api/local";
import * as activityConstants from "../constants/activityConstants.js";
import history from "../config/history";
import { errorHandler } from "./errorHandler";

export const fetchActivities = () => async (dispatch) => {
  dispatch({
    type: activityConstants.ACTIVITY_LIST_REQUEST,
  });
  try {
    const data = await localAPI.get(`/api/activities`);
    dispatch({ type: activityConstants.ACTIVITY_LIST_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(activityConstants.ACTIVITY_LIST_FAIL, error, false, dispatch);
  }
};

export const fetchActivitiesAdmin = (handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: activityConstants.ACTIVITY_LIST_REQUEST,
  });
  try {
    const data = await localAPI.get("/api/activities/admin");
    dispatch({ type: activityConstants.ACTIVITY_LIST_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(activityConstants.ACTIVITY_LIST_FAIL, error, false, dispatch);
  }
};

export const fetchActivity = (activityId) => async (dispatch) => {
  dispatch({
    type: activityConstants.ACTIVITY_DETAILS_REQUEST,
  });
  try {
    const data = await localAPI.get(`/api/activities/link/${activityId}`);
    await dispatch({
      type: activityConstants.ACTIVITY_DETAILS_SUCCESS,
      payload: data,
    });
    return data.data.activityLink;
  } catch (error) {
    errorHandler(
      activityConstants.ACTIVITY_DETAILS_FAIL,
      error,
      false,
      dispatch
    );
  }
};

export const createActivity =
  (activity, handleSignInOpen) => async (dispatch) => {
    dispatch({
      type: activityConstants.ACTIVITY_CREATE_REQUEST,
    });
    try {
      const data = await localAPI.post("/api/activities", activity);
      dispatch({
        type: activityConstants.ACTIVITY_CREATE_SUCCESS,
        payload: data,
      });
      history.go(0);
    } catch (error) {
      errorHandler(
        activityConstants.ACTIVITY_CREATE_FAIL,
        error,
        false,
        dispatch
      );
    }
  };

export const editActivity =
  (activity, handleSignInOpen) => async (dispatch) => {
    dispatch({
      type: activityConstants.ACTIVITY_UPDATE_REQUEST,
    });
    try {
      const data = await localAPI.patch(
        `/api/activities/${activity._id}`,
        activity
      );
      dispatch({
        type: activityConstants.ACTIVITY_UPDATE_SUCCESS,
        payload: data,
      });
      history.go(0);
    } catch (error) {
      errorHandler(
        activityConstants.ACTIVITY_UPDATE_FAIL,
        error,
        false,
        dispatch
      );
    }
  };

export const deleteActivity =
  (activityId, handleSignInOpen) => async (dispatch) => {
    dispatch({
      type: activityConstants.ACTIVITY_DELETE_REQUEST,
    });
    try {
      const data = await localAPI.delete(`/api/activities/${activityId}`);
      dispatch({
        type: activityConstants.ACTIVITY_DELETE_SUCCESS,
        payload: data,
      });
      history.go(0);
    } catch (error) {
      errorHandler(
        activityConstants.ACTIVITY_DELETE_FAIL,
        error,
        false,
        dispatch
      );
    }
  };
